import { FormGroup, Radio, RadioGroup } from '@ksyos/design-system';
import type { FundusScreeningManualImportFrontendSchemaValidated } from '@common/validation/fundusScreening';
import { FundusScreeningThirdParty } from '@common/fundusScreening/thirdParties';
import { getSelectedLanguage } from '@frontend/translate';
import { useFormContext } from '@frontend/utils/hooks/useFormContext';

export function SelectThirdParty() {
    const form = useFormContext<FundusScreeningManualImportFrontendSchemaValidated>();
    const translate = getSelectedLanguage();

    return (
        <FormGroup
            hasErrors={form.errors.has('thirdParty')}
            isRequired={true}
            label={translate.fundusScreening.manualImport.form.thirdPartyFieldLabel}
        >
            <RadioGroup
                error={form.errors.getMessage('thirdParty')}
                onChange={(option) => {
                    form.handleChange({ name: 'thirdParty', value: option?.target.value ?? null });
                }}
                value={form.values.thirdParty}
            >
                <Radio
                    label={
                        translate.fundusScreening.manualImport.thirdParty[
                            FundusScreeningThirdParty.vipLiveFundusManualImport
                        ]
                    }
                    value={FundusScreeningThirdParty.vipLiveFundusManualImport}
                ></Radio>
                <Radio
                    label={
                        translate.fundusScreening.manualImport.thirdParty[
                            FundusScreeningThirdParty.healthConnectedFundusManualImport
                        ]
                    }
                    value={FundusScreeningThirdParty.healthConnectedFundusManualImport}
                ></Radio>
            </RadioGroup>
        </FormGroup>
    );
}
